/**
 * コンテンツ一覧
 */

import React from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Typography,
    Button,
    MenuList,
    MenuItem,
    Grid,
    ClickAwayListener,
    Tooltip,
    DialogTitle,
} from '@material-ui/core';
import {
    getContentSearch,
    contentDelete,
    getParentId
} from 'mdoc/admin/axios/content'
import { dictionary, getPermissions } from 'mdoc/admin/axios'
import CustomizedTable from 'mdoc/utils/table'
import Star from 'mdoc/utils/Star'
import { Link } from 'react-router-dom'
import { dateFormat } from 'mdoc/utils'
import Dialog from 'mdoc/utils/myDialog'
import * as config from 'mdoc/admin/axios/config'
import Toast from 'mdoc/utils/toast';
import CustomizedSearchInput from 'mdoc/utils/CustomizedSearchInput';

const styles = theme => ({
    appBarSpacer: theme.mixins.toolbar,
    margin: {
        margin: theme.spacing.unit,
    },
    Radio: {
        padding: '0px 10px'
    },
    link: {
        color: '#2196f3',
        textDecoration: 'none',
        cursor:'pointer'
    },
    tip: {
        background: '#2096fb',
    },
    item: {
        color: '#ffffff',
    },
    title: {
        marginLeft: '-20px'
    }
});
class Content extends React.Component {
    state = {
        selectedRowKeys: [], // Check here to configure the default column
        data: [],
        loading: false,
        permissions: [],
        pagination: {
            pageNumber: 1,
            pageSize: 25,
            count: 0,
            sidx: '',
            sord: ''
        },
        dictWord: {
            'content_registration': '',
            'content_multiple_registration': '',
            'content_log': '',
            'id': '',
            'notice_title': '',
            'category': '',
            'file_form': '',
            'published_user': '',
            'registration_date': '',
            'update_date': '',
            'evaluation': '',
            'book_open_state': '',
            'modify_record': '',
            'delete_record': '',
            'non_public': '',
            'public': '',
            'yes': '',
            'cancel': '',
            'msg_confirm_really_delete': '',
            'management': '',
            'msg_error_record_not_found': '',
            'confirmation': '',
        },
        openStatus: config['NOTIFY_STATUS_DETAIL'],
        search: '',
        dialogOpen: false,
        bookId: '',
        open: false,
        TooltipOpen: [],
        docMstBookCategoryList: null,
        categoryName: '',
    }
    componentWillMount() {
        this.start(this.state);
    }
    componentDidMount() {
        const permissions = getPermissions() !== undefined ? getPermissions() : [];
        this.setState({
            permissions: permissions
        });
    }
    start = (state) => {
        this.setState({ loading: true });
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        })
    }

    fetch = (params = {}) => {
        this.setState({ loading: true })
        getContentSearch({
            ...params,
        }).then((data) => {
            const pagination = { ...this.state.pagination, ...params }
            pagination.count = data.count;
            if (data.results === undefined) {
                Toast.info(this.state.dictWord.msg_error_record_not_found)
            }
            this.setState({
                loading: false,
                data: data.results !== undefined ? data.results : [],
                pagination: pagination,
            })
        }).catch(error => {
            Toast.info(error)
        })
    }


    handleTableChange = (event, pagination) => {
        this.fetch({
            searchKeyword: this.state.search,
            pageNumber: pagination.page,
            pageSize: pagination.rowsPerPage,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    }
    handleTableSort = (event, property) => {
        const sidx = property;
        let sord = 'desc';

        let pagination = this.state.pagination;
        if (pagination.sidx === property && pagination.sord === 'desc') {
            sord = 'asc';
        }
        pagination['sord'] = sord;
        pagination['sidx'] = sidx;
        this.setState({
            pagination: pagination
        });
        this.fetch({
            searchKeyword: this.state.search,
            pageNumber: this.state.pagination.pageNumber,
            pageSize: this.state.pagination.pageSize,
            sidx: this.state.pagination.sidx,
            sord: this.state.pagination.sord,
        })
    };
    //削除
    handleSubmit = (id) => event => {
        this.setState({
            bookId: id,
            dialogOpen: true
        });
    }
    dialogHandleOK = (event) => {
        contentDelete(this.state.bookId).then(res => {
            window.location.reload()
        }).catch(function (error) {
            Toast.error(error);
        })
    }
    dialogHandleClose = () => {
        this.setState({
            dialogOpen: false
        });
    }
    handleSearch(kerWords) {
        this.setState({
            search:kerWords
        },()=>{
            this.fetch({
                searchKeyword: this.state.search,
                pageNumber: this.state.pagination.pageNumber,
                pageSize: this.state.pagination.pageSize,
                sidx: this.state.pagination.sidx,
                sord: this.state.pagination.sord,
            });
        });
    }
    handleTooltipOpens = (id, parentId) => event => {
        getParentId(
            { parentIds: parentId }
        ).then((data) => {
            let docMstBookCategoryList = data.results;
            let TooltipOpen = this.state.TooltipOpen;
            if (!TooltipOpen.includes(id)) {
                TooltipOpen.push(id);
            }
            this.setState({
                TooltipOpen: TooltipOpen,
                docMstBookCategoryList: docMstBookCategoryList
            })
        })
    }
    handleTooltipClose = (id) => event => {
        let TooltipOpen = this.state.TooltipOpen;
        if (TooltipOpen.includes(id)) {
            let index = TooltipOpen.indexOf(id);
            TooltipOpen.splice(index, 1);
        }
        this.setState({ TooltipOpen: TooltipOpen });
    };
    render() {
        const { classes } = this.props;
        const { permissions } = this.state;
        const columns = [
            {
                title: this.state.dictWord.id,
                dataIndex: 'bookCode',
                sorter: true,
                sortIndex: 'bookCode',
                width: '90px',
                render: (text, record) => <Link to={{ pathname: '/admin/content/contentedit/' + record.id }} className={classes.link}>{text}</Link>,
            }, {
                title: this.state.dictWord.notice_title,
                dataIndex: 'title',
                sorter: true,
                width: '125px',
            }, {
                title: this.state.dictWord.category,
                dataIndex: 'status',
                width: '141px',
                toolTipDisabled: true,
                render: (text, record) => {
                    let category = <span className={classes.link}>{record.docMstBookCategory.categoryName}</span>;
                    if (record.docMstBookCategory.parentIds.length > 0) {
                        category = <ClickAwayListener onClickAway={this.handleTooltipClose(record.id)}>
                            <Tooltip
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                onClose={this.handleTooltipClose(record.id)}
                                open={this.state.TooltipOpen.includes(record.id)}
                                classes={{ tooltip: classes.tip }}
                                placement="top"
                                title={this.state.docMstBookCategoryList ? <MenuList>
                                    {this.state.docMstBookCategoryList.map((item, index) => {
                                        return <MenuItem key={index} style={{ marginLeft: 20 * (item.depth - 1) }} className={classes.item}><span>{item.categoryName}</span></MenuItem>;
                                    })}
                                </MenuList> : ''}
                            >
                                <span className={classes.link} onClick={this.handleTooltipOpens(record.id, record.docMstBookCategory.parentIds)}>{record.docMstBookCategory.categoryName}</span>
                            </Tooltip></ClickAwayListener>
                    }
                    return category;
                }
            }, {
                title: this.state.dictWord.file_form,
                dataIndex: 'docType',
                width: '80px',
            }, {
                title: this.state.dictWord.published_user,
                dataIndex: 'author',
                width: '117px',
            }, {
                title: this.state.dictWord.registration_date,
                dataIndex: 'createDate',
                sorter: true,
                width: '90px',

                render: (date, fmt) => {
                    return dateFormat(new Date(date), 'yyyy/MM/dd');
                }
            }, {
                title: this.state.dictWord.update_date,
                dataIndex: 'updateDate',
                sorter: true,
                width: '90px',
                render: (date, fmt) => {
                    return dateFormat(new Date(date), 'yyyy/MM/dd');
                }
            }, {
                title: this.state.dictWord.evaluation,
                dataIndex: 'averageScore',
                sorter: true,
                width: '100px',
                toolTipDisabled: true,
                render: (text, record) => {
                    if (record['isOpen'] === 1) {
                        return <span>-</span>
                    } else {
                        return <Star enableClick={false} starPercent={record.averageScore} />
                    }
                }
            }, {
                title: this.state.dictWord.book_open_state,
                dataIndex: 'isOpen',
                width: '70px',
                render: (text, record) => {
                    if (record['isOpen'] === 1) {
                        return this.state.dictWord[this.state.openStatus[1]];
                    } else {
                        return this.state.dictWord[this.state.openStatus[0]];
                    }
                }
            },
        ]

        if (permissions.includes(8)) {
            columns.push({
                title: this.state.dictWord.management,
                key: 'action',
                width: '130px',
                style:{
                    overflow: 'none',
                },
                toolTipDisabled: true,
                render: (text, record) => (
                    <span>
                        <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/content/contentedit/' + record.id}>{this.state.dictWord.modify_record}</Button>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit(record.id)} className={classes.margin}>{this.state.dictWord.delete_record}</Button>
                    </span>
                )
            });
        }
        return (
            <div className="mainDom">
                <div className={classes.appBarSpacer} />
                <Grid container direction="row" justify="space-between" alignItems="center" >
                    <Grid item xs={12} md={8}>
                        {permissions.includes(8) ? <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/content/contentedit'}>
                            {this.state.dictWord.content_registration}
                        </Button> : null}
                        {permissions.includes(8) && permissions.includes(10) ? <Button variant="contained" color="primary" className={classes.margin} href={'/admin.html#/admin/content/content_alledit'}>
                            {this.state.dictWord.content_multiple_registration}
                        </Button> : null}
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CustomizedSearchInput onClick={this.handleSearch.bind(this)} />
                    </Grid>
                </Grid>
                <Typography component="div" className={classes.margin}>
                    <CustomizedTable
                        data={this.state.data}
                        columns={columns}
                        count={this.state.pagination.count}
                        page={this.state.pagination.pageNumber}
                        rowsPerPage={this.state.pagination.pageSize}
                        onChange={this.handleTableChange}
                        sord={this.state.pagination.sord}
                        sidx={this.state.pagination.sidx}
                        onSort={this.handleTableSort}
                    />
                </Typography>
                <Dialog
                    open={this.state.dialogOpen}
                    option={{
                        ok: {
                            text: this.state.dictWord['yes'],
                        },
                        close: {
                            text: this.state.dictWord['cancel'],
                        },
                    }}
                    titleDoc={<DialogTitle disableTypography id="" className={classes.title}>{this.state.dictWord['confirmation']}</DialogTitle>}
                    content={
                        <p>{this.state.dictWord['msg_confirm_really_delete']}</p>
                    }
                    handleOk={this.dialogHandleOK}
                    handleClose={this.dialogHandleClose}
                />
            </div>
        )
    }
}

Content.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);